import { render, staticRenderFns } from "./EcoBlockAnchor.vue?vue&type=template&id=29f1fcb9&"
import script from "./EcoBlockAnchor.vue?vue&type=script&lang=js&"
export * from "./EcoBlockAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports